import { UseQueryOptions } from '@tanstack/react-query';

import { shutdownBannerSupportsShutdown } from '@repo/sdk/funcs/shutdownBannerSupportsShutdown';
import { SDKError } from '@repo/sdk/models/errors';
import { SupportsShutdownRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface GetSupportsShutdownQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
}

export const supportsShutdownQuery = ({
  agentId,
  client,
}: GetSupportsShutdownQueryProps): UseQueryOptions<boolean, SDKError, boolean | undefined> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'supportsShutdown'],
    queryFn: () =>
      client<SupportsShutdownRequest, boolean>({
        gaiaFunc: shutdownBannerSupportsShutdown,
        request: {
          agentId: agentId!,
        },
      }),
    staleTime: Infinity,
  };
};
